const styles = theme => ({
  root: {
    boxShadow: 'none',
  },
  flexGrow: {
    flexGrow: 1,
  },
  logo: {
    fontSize: 0,
    width: '90px',
    [theme.breakpoints.up('md')]: {
      width: '130px',
    },
  },
  checkoutButton: {
    color: theme.palette.white,
  },
  logoutButton: {
    marginLeft: theme.spacing(4),
  },
})

export default styles
